/*
 * Public API Surface of zxing-scanner
 */

export * from '../../zxing-scanner/src/public_api';
